require('./all')

//scss
import '../../scss/site/calc.scss'
//

import {doScrolling} from '../_helpers'

// core version + navigation, pagination modules:
import Swiper, { Navigation, EffectFade } from 'swiper';
import 'swiper/swiper-bundle.css';

// configure Swiper to use modules
Swiper.use([Navigation, EffectFade]);

const bootstrap_collapse = require('bootstrap/js/dist/collapse');

var nav = document.getElementById('nav-menu-box')

nav.addEventListener('show.bs.collapse', function () {
    nav.parentElement.parentElement.parentElement.classList.add('show')
})

nav.addEventListener('hide.bs.collapse', function () {
    nav.parentElement.parentElement.parentElement.classList.remove('show')
})

var mySwiper = new Swiper('.swiper-container', {
    loop: false,
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    allowTouchMove: false,
    navigation: {
        nextEl: '.next',
        prevEl: '.prev',
    },
}).on('slideChange', function () {
    doScrolling(document.getElementById('calc').querySelector('.grps'), 300, 30)
});

//
var formats_inputs = document.querySelectorAll('input[type=\"checkbox\"][name=\"formats\"]')
var modal_formats = document.querySelector('input[type=\"hidden\"][name=\"formats\"]')
if(formats_inputs){
    Array.prototype.forEach.call(formats_inputs, function (format_input) {
        var format_label = format_input.nextElementSibling

        format_label.addEventListener('click', function (){
            var formats_selected = []
            format_input.checked = format_input.checked ? false : true
            Array.prototype.forEach.call(formats_inputs, function (input) {
                if(input.checked) formats_selected.push(input.value)
            })
            modal_formats.value = formats_selected ? formats_selected.join(', ') : ''
        })
    })
}

var rooms_inputs = document.querySelectorAll('input[type=\"checkbox\"][name=\"rooms\"]')
var modal_rooms = document.querySelector('input[type=\"hidden\"][name=\"rooms\"]')
if(rooms_inputs){
    Array.prototype.forEach.call(rooms_inputs, function (room_input) {
        var room_label = room_input.nextElementSibling
        room_label.addEventListener('click', function (){
            var rooms_selected = []
            room_input.checked = room_input.checked ? false : true
            Array.prototype.forEach.call(rooms_inputs, function (input) {
                if(input.checked) rooms_selected.push(input.value)
            })
            modal_rooms.value = rooms_selected ? rooms_selected.join(', ') : ''
            console.log(modal_rooms.value)
        })
    })
}

var volumes_inputs = document.querySelectorAll('input[type=\"checkbox\"][name=\"volumes\"]')
var modal_volumes = document.querySelector('input[type=\"hidden\"][name=\"volumes\"]')
if(volumes_inputs){
    Array.prototype.forEach.call(volumes_inputs, function (volume_input) {

        var volume_label = volume_input.nextElementSibling
        volume_label.addEventListener('click', function (){
            var volumes_selected = []
            volume_input.checked = volume_input.checked ? false : true
            Array.prototype.forEach.call(volumes_inputs, function (input) {
                if(input.checked) volumes_selected.push(input.value.replace(/(<([^>]+)>)/gi, " ").trim())
            })
            modal_volumes.value = volumes_selected ? volumes_selected.join(', ') : ''
            console.log(modal_volumes.value)
        })

    })
}

var ends_inputs = document.querySelectorAll('input[type=\"checkbox\"][name=\"ends\"]')
var modal_ends = document.querySelector('input[type=\"hidden\"][name=\"ends\"]')
if(ends_inputs){
    Array.prototype.forEach.call(ends_inputs, function (end_input) {
        var end_label = end_input.nextElementSibling
        end_label.addEventListener('click', function (){
            var ends_selected = []
            end_input.checked = end_input.checked ? false : true
            Array.prototype.forEach.call(ends_inputs, function (input) {
                if(input.checked) ends_selected.push(input.value)
            })
            modal_ends.value = ends_selected ? ends_selected.join(', ') : ''
            console.log(modal_ends.value)
        })
    })
}

var pays_inputs = document.querySelectorAll('input[type=\"checkbox\"][name=\"pays\"]')
var modal_pays = document.querySelector('input[type=\"hidden\"][name=\"pays\"]')
if(pays_inputs){
    Array.prototype.forEach.call(pays_inputs, function (pay_input) {
        var pay_label = pay_input.nextElementSibling
        pay_label.addEventListener('click', function (){
            var pays_selected = []
            pay_input.checked = pay_input.checked ? false : true
            Array.prototype.forEach.call(ends_inputs, function (input) {
                if(input.checked) pays_selected.push(input.value)
            })
            modal_pays.value = pays_selected ? pays_selected.join(', ') : ''
            console.log(modal_pays.value)
        })
    })
}
